import {FC} from 'react'
import capitalize from 'lodash/capitalize'

type Props = {
  shippingPackage: any
  selected: boolean
  onChange: (shippingPackage: any) => void
}

const PackageItem: FC<Props> = ({shippingPackage, onChange, selected}) => {
  const {dimension, weight} = shippingPackage

  const handleSelect = () => {
    onChange(shippingPackage)
  }

  return (
    <div className='d-flex align-items-center mb-8'>
      <span className='bullet bullet-vertical h-40px bg-success'></span>

      <div className='flex-grow-1 mx-5'>
        <span className='text-gray-800 text-hover-primary fw-bolder fs-6'>
          {shippingPackage.name}
        </span>
        <span className='text-muted fw-bold d-block'>
          {dimension.length} x {dimension.width} x {dimension.height} {capitalize(dimension.units)}{' '}
          , {weight.value} {weight.units}
        </span>
      </div>

      <div className='form-check form-check-custom form-check-solid me-6'>
        <input
          id='radioInput'
          className='form-check-input'
          type='radio'
          checked={selected}
          title='select'
          onChange={handleSelect}
        />
      </div>
    </div>
  )
}

export default PackageItem
